/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistics — Full leaderboards and individual profiles for every driver and constructor, covering race results, fantasy points, price history, and season performance.`)
};

const es_about_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas — Tablas completas y perfiles individuales para cada piloto y constructor, cubriendo resultados de carrera, puntos fantasy, historial de precios y rendimiento de temporada.`)
};

const de_about_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiken — Vollständige Bestenlisten und Einzelprofile für jeden Fahrer und Konstrukteur, mit Rennergebnissen, Fantasy-Punkten, Preisverlauf und Saisonleistung.`)
};

const nl_about_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistieken — Volledige ranglijsten en individuele profielen voor elke coureur en constructeur, met raceresultaten, fantasy-punten, prijshistorie en seizoensprestaties.`)
};

const fr_about_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques — Classements complets et profils individuels pour chaque pilote et constructeur, couvrant les résultats de course, les points fantasy, l’historique des prix et les performances de saison.`)
};

const it_about_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche — Classifiche complete e profili individuali per ogni pilota e costruttore, con risultati gare, punti fantasy, storico prezzi e prestazioni stagionali.`)
};

const pt_br2_about_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas — Classificações completas e perfis individuais para cada piloto e construtor, cobrindo resultados de corridas, pontos fantasy, histórico de preços e desempenho na temporada.`)
};

const pt_about_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas — Tabelas de líderes e perfis individuais para cada piloto e construtor, cobrindo resultados de corrida, pontos fantasy, historial de preços e desempenho na época.`)
};

const ja_about_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`統計 — すべてのドライバーとコンストラクターの完全なリーダーボードと個別プロフィール。レース結果、ファンタジーポイント、価格履歴、シーズンパフォーマンスをカバー。`)
};

const zh_about_stats_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`统计数据 — 每位车手和车队的完整排行榜和个人档案，涵盖比赛结果、梦幻积分、价格历史和赛季表现。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_stats_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_stats_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_stats_desc", locale)
	if (locale === "en") return en_about_stats_desc(inputs)
	if (locale === "es") return es_about_stats_desc(inputs)
	if (locale === "de") return de_about_stats_desc(inputs)
	if (locale === "nl") return nl_about_stats_desc(inputs)
	if (locale === "fr") return fr_about_stats_desc(inputs)
	if (locale === "it") return it_about_stats_desc(inputs)
	if (locale === "pt-BR") return pt_br2_about_stats_desc(inputs)
	if (locale === "pt") return pt_about_stats_desc(inputs)
	if (locale === "ja") return ja_about_stats_desc(inputs)
	return zh_about_stats_desc(inputs)
};